import Base from "./base.service.js";
export default class RepairItem extends Base {
    constructor() {
        super("replaced-spare-part");
    }
}
